module.exports = __webpack_public_path__ + "assets/02b97d3c4a7e895228beec69fb63e420.js";